import { AxiosResponse } from 'axios';
import { api } from './config';
import {
  Vehicle, VehicleCapacityTons, CreateVehicleCapacityTons,
  Driver, CreateDriver
} from '../../types';

export const vehicleApi = {
  getAll: (): Promise<AxiosResponse<Vehicle[]>> =>
    api.get('/vehicle'),
    
  getById: (id: number): Promise<AxiosResponse<Vehicle>> =>
    api.get(`/vehicle/${id}`),
    
  create: (data: any): Promise<AxiosResponse<Vehicle>> =>
    api.post('/vehicle', data),
    
  update: (id: number, data: any): Promise<AxiosResponse<Vehicle>> =>
    api.put(`/vehicle/${id}`, data),
    
  delete: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/vehicle/${id}`)
};

// Vehicle Capacity Tons API
export const vehicleCapacityTonsApi = {
  getAll: (): Promise<AxiosResponse<VehicleCapacityTons[]>> =>
    api.get('/vehiclecapacitytons'),
    
  getAllIncludeInactive: (): Promise<AxiosResponse<VehicleCapacityTons[]>> =>
    api.get('/vehiclecapacitytons/all'),
    
  getById: (id: number): Promise<AxiosResponse<VehicleCapacityTons>> =>
    api.get(`/vehiclecapacitytons/${id}`),
    
  create: (data: CreateVehicleCapacityTons): Promise<AxiosResponse<VehicleCapacityTons>> =>
    api.post('/vehiclecapacitytons', data),
    
  update: (id: number, data: CreateVehicleCapacityTons): Promise<AxiosResponse<VehicleCapacityTons>> =>
    api.put(`/vehiclecapacitytons/${id}`, data),
    
  delete: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/vehiclecapacitytons/${id}`)
};

// Toll Fee API
export const driverApi = {
  getAll: (): Promise<AxiosResponse<Driver[]>> =>
    api.get('/driver'),
  getById: (id: number): Promise<AxiosResponse<Driver>> =>
    api.get(`/driver/${id}`),
  create: (data: CreateDriver): Promise<AxiosResponse<Driver>> =>
  api.post('/driver', data),
  update: (id: number, data: CreateDriver): Promise<AxiosResponse<void>> =>
    api.put(`/driver/${id}`, data),
  delete: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/driver/${id}`),
  getSalaryHistory: (driverId: number): Promise<AxiosResponse<any[]>> =>
    api.get(`/driversalaryhistory/${driverId}`),
  getDriverSalaryRate: (driverId: number, shippingDate: string): Promise<AxiosResponse<{ salaryRate: number }>> =>
    api.get('/driversalaryhistory/latest', { params: { driverId, asOfDate: shippingDate } }),
  deleteSalaryHistory: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/driversalaryhistory/${id}`),
};

// AI Model API
